// extracted by mini-css-extract-plugin
export default {"root":"ArrangePages_root__EFiZY","currentPage-totalPage":"ArrangePages_currentPage-totalPage__oXOva"};